import { c as _c } from "react/compiler-runtime";
import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

/** Teal pill promising the file stays on the device. */
export function PrivacyBadge(t0) {
  const $ = _c(6);
  const {
    children: t1,
    className
  } = t0;
  const children = t1 === undefined ? "Processed on your device" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-flex items-center gap-2 rounded-full bg-image-tint px-3 py-1.5 text-sm font-semibold text-image-strong", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShieldCheck className="size-4 shrink-0" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t2) {
    t4 = <span className={t2}>{t3}{children}</span>;
    $[3] = children;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}